module.exports = __webpack_public_path__ + "static/media/bos.c9a32403.svg";